import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useLocalStorage from "../../hooks/useLocalStorage";

function Profile() {
  const { id, name, user_type, client_id, vendor_id } = useLocalStorage();
  const accountDetails = [
    { label: "Username", value: name || "Not available" },
    { label: "Account type", value: user_type || "Not available" },
    ...(id ? [{ label: "User ID", value: String(id) }] : []),
    ...(client_id
      ? [{ label: "Client ID", value: String(client_id) }]
      : []),
    ...(vendor_id
      ? [{ label: "Vendor ID", value: String(vendor_id) }]
      : []),
  ];

  return (
    <Box sx={{ width: "100%", maxWidth: 720, mx: "auto", py: { xs: 2, md: 4 } }}>
      <Typography variant="h5" fontWeight={700} sx={{ mb: 0.5 }}>
        Profile
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        View the account information associated with your session.
      </Typography>

      <Paper variant="outlined" sx={{ overflow: "hidden", borderRadius: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          sx={{ p: { xs: 2.5, sm: 3 } }}
        >
          <Avatar
            sx={{
              width: 64,
              height: 64,
              bgcolor: "primary.main",
              fontSize: 24,
              fontWeight: 700,
            }}
          >
            {name?.charAt(0).toUpperCase() || "U"}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" fontWeight={700} noWrap>
              {name || "User"}
            </Typography>
            <Typography color="text.secondary">
              {user_type || "Account"}
            </Typography>
          </Box>
        </Stack>

        <Divider />

        <Stack divider={<Divider flexItem />} sx={{ px: { xs: 2.5, sm: 3 } }}>
          {accountDetails.map((detail) => (
            <Box
              key={detail.label}
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", sm: "180px 1fr" },
                gap: { xs: 0.5, sm: 2 },
                py: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                {detail.label}
              </Typography>
              <Typography variant="body2" fontWeight={500}>
                {detail.value}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
}

export default Profile;
